import { createGlobalStyle } from 'styled-components'
import { reset } from 'styled-reset'
import { Color, ColorShade, BaseColor, themeColor, opaqueColor } from './palette'
import { FontFamily, Typography } from './typography'
import { backgroundColor, textColor } from './utility'

const GlobalStyles = createGlobalStyle`
  ${reset};
  
  *,
  *::after,
  *::before {
    box-sizing: border-box;
  }
  
  ::selection {
    color: ${themeColor(BaseColor.max)};
    background: ${opaqueColor(themeColor(Color.primary, ColorShade.soft))};
  }

  html, body {
    height: 100%;
  }
  
  html {
    font-size: ${props => props.theme.remBase}px !important;
    -ms-overflow-style: -ms-autohiding-scrollbar;
    -webkit-text-size-adjust: none;
  }
  
  body {
    min-width: 320px;
    background-color: ${backgroundColor};
    color: ${textColor};
    
    font-family: ${FontFamily.inter};
    font-feature-settings: 'ss01', 'cv05', 'cv08';
    ${Typography.bodyMedium};
  }

  a, button {
    cursor: pointer;
  }

  button {
    font-feature-settings: inherit;
    appearance: none;
    background: transparent;
    border: 0;

    &:focus {
      outline: 0;
    }
  }
  
  input, textarea, select, button {
    font: inherit;
  }

  img {
    display: block;
    max-width: 100%;
    height: auto;
  }
`

export default GlobalStyles
